import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

interface PassportSectionFallbackProps {
  sectionName: string;
  /**
   * Render the message ALONE, without the surrounding Card.
   *
   * Some sections fail whole — the component can return this instead of itself,
   * and the card is the right frame. Others fail INSIDE a card that is already
   * open (the CRUD sections put their loading, empty and populated branches in
   * one `CardContent`), and nesting a second Card there would be a different
   * shape on screen for the same event. One primitive, two placements, so the
   * Passport keeps a single vocabulary for "this could not be read".
   */
  inline?: boolean;
}

export function PassportSectionFallback({
  sectionName,
  inline = false,
}: PassportSectionFallbackProps) {
  const message = (
    <>
      <AlertTriangle className="h-4 w-4 text-destructive flex-shrink-0" />
      <span>{sectionName} section failed to load.</span>
    </>
  );

  if (inline) {
    return (
      <div className="py-4 flex items-center justify-center gap-3 text-sm text-muted-foreground">
        {message}
      </div>
    );
  }

  return (
    <Card className="border-destructive/30">
      <CardContent className="py-4 flex items-center gap-3 text-sm text-muted-foreground">
        {message}
      </CardContent>
    </Card>
  );
}
